import classNames from 'classnames';
import { Tooltip } from 'antd';
import { ReactNode } from 'react';

import styles from './MenuItem.module.scss';

interface IProps {
  readonly icon: ReactNode;
  readonly text: string;
  readonly collapsed: boolean;
  readonly onClick?: () => void;
}

export const MenuButton = ({ icon, text, collapsed, onClick }: IProps) => {
  return (
    <Tooltip title={collapsed ? text : null} placement="right">
      <button
        type="button"
        aria-label={text}
        className={classNames(styles.navigationItem, { [styles.compact]: collapsed })}
        onClick={onClick}
      >
        {icon}
        <span className={styles.text}>{text}</span>
      </button>
    </Tooltip>
  );
};
